
























































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator'
import { MdDataBomTemplate } from '@/module/graphql'
import { Message } from 'element-ui'

@Component
export default class CmpMdBomTemplateChooser extends Vue {
  @Prop({ required: true }) readonly bomTemplates!: MdDataBomTemplate[]
  @Prop() readonly currentBomTemplate?: MdDataBomTemplate

  @PropSync('visible')
  syncedVisible!: boolean

  private mSelectedRow: MdDataBomTemplate | null = null;

  private onRowSelected(bomTemplate: MdDataBomTemplate) {
    this.mSelectedRow = bomTemplate
  }

  private confirmSelected() {
    if (!this.mSelectedRow) {
      Message({
        message: '请先选择一个Bom模板',
        type: 'error',
        duration: 3 * 1000,
        showClose: true
      })
      return
    }
    this.$emit('select', this.mSelectedRow)
    this.syncedVisible = false
  }
}
